module.exports = __webpack_public_path__ + "static/media/guide_img2_2.77a422b6.png";